'use strict';

var novicell = novicell || {}; // eslint-disable-line

novicell.gobackRedirect = novicell.gobackRedirect || new function () {
    this.init = function () {
        let goBackArrows = document.querySelectorAll(".arrow-button--back-button");
        if(!goBackArrows) {
            return;
        }
        for(let i = 0; i < goBackArrows.length; i++)
        {
            goBackArrows[i].addEventListener("click", () => {
                window.history.back();
            } 
            );
        }
       
    };
}();